import React, { useEffect, useState } from "react"
import OtpInput from "../../../components/InputBoxes/OTPInput"
import EditIcon from "../../../assets/Icons/EditIcon"
import "../landingPage.css"
const waitingTime = 45
const OTPSection = ({
  onChange,
  otp = "",
  onClickEdit = () => {},
  sendOTP = () => {},
  visible = false,
  phoneNumber = "",
}) => {
  const [resendTimer, setResendTimer] = useState(waitingTime)

  useEffect(() => {
    if (visible) {
      sendOTP()
      setResendTimer(waitingTime) // Reset the timer when OTP is sent
    }
  }, [visible])

  useEffect(() => {
    let intervalId = null

    if (resendTimer > 0 && resendTimer <= waitingTime) {
      intervalId = setInterval(() => {
        setResendTimer((prevTimer) => prevTimer - 1)
      }, 1000)
    }

    return () => {
      clearInterval(intervalId)
    }
  }, [resendTimer])

  const userData = isNaN(phoneNumber) ? phoneNumber : `+91 ${phoneNumber.replace(/^\d{6}/, "******")}`

  const onClick = () => {
    if (resendTimer <= 0) {
      sendOTP()
      setResendTimer(waitingTime)
    }
  }
  return (
    <div className={`sliding-panel flex flex-col ${visible ? "" : "slideData"} `}>
      {visible ? (
        <>
          <p className="text-[#424952D9] font-[400] text-[14px] leading-[22px]  mb-[20px] text-nowrap">
            Please enter the OTP that has been sent on <br />
            <span className="font-[700]">
              {userData}{" "}
              <span className="text-[#04B085] font-[600] ml-[5px] inline-flex cursor-pointer" onClick={onClickEdit}>
                edit <span className="ml-[5px]"><EditIcon/></span>
              </span>
            </span>
          </p>

          <OtpInput length={4} onChange={(data) => onChange(data)} value={otp} name="otp" />
          
            <p className="font-[500] text-[16px] leading-[24px] mt-[8px] text-[#42495280] text-nowrap">
              Didn’t get the code?{" "}
              <a className={`${resendTimer ? "text-[#00C08B80] " : "text-[#04B085] cursor-pointer underline"}`} onClick={onClick}>
                Click to resend
              </a>
              {" "}
              {resendTimer > 0 && <div className="text-[#04B085] inline-flex w-[130px]">Try again in {resendTimer}s</div>}
            </p>          
        </>
      ) : (
        <></>
      )}
    </div>
  )
}

export default OTPSection
